//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ShowText from "@/0/components/comForm/comDetailControls/comShowText.vue";
import ShowTable from "@/0/components/comForm/comDetailControls/comShowTable.vue";

import EditCommon from "@/0/components/comForm/comEditControls/Common/comEditCommon.vue";
import EditDev01 from "@/0/components/comForm/comEditControls/Common/comDev01.vue";
import EditDev02 from "@/0/components/comForm/comEditControls/Common/comDev02.vue";
import EditDev03 from "@/0/components/comForm/comEditControls/Common/comDev03.vue";
import EditDev04 from "@/0/components/comForm/comEditControls/Common/comDev04.vue";
import EditDev05 from "@/0/components/comForm/comEditControls/Common/comDev05.vue";
import EditDev06 from "@/0/components/comForm/comEditControls/Common/comDev06.vue";
import EditDev07 from "@/0/components/comForm/comEditControls/Common/comDev07.vue";


import EditHidden from "@/0/components/comForm/comEditControls/comEditHidden.vue";

import EditInput from "@/0/components/comForm/comEditControls/comEditInput.vue";
import EditTextArea from "@/0/components/comForm/comEditControls/comEditTextArea.vue";

import EditDate from "@/0/components/comForm/comEditControls/comEditDate.vue";
import EditDateTime from "@/0/components/comForm/comEditControls/comEditDateTime.vue";

import EditSwitch from "@/0/components/comForm/comEditControls/comEditSwitch.vue";
import EditCheckBox from "@/0/components/comForm/comEditControls/comEditCheckBox.vue";

import EditDropDownList from "@/0/components/comForm/comEditControls/comEditDropDownList.vue";
import EditRadioGroup from "@/0/components/comForm/comEditControls/comEditRadioGroup.vue";
import EditDropDownDetail from "@/0/components/comForm/comEditControls/comSelectDetail.vue";

import EditLinkedDropDownList from "@/0/components/comForm/comEditControls/comEditLinkedDropDownList/comIndex.vue";

import EditUploader from "@/0/components/comForm/comEditControls/comEditUploader.vue";

import ShowImagesList from "@/0/components/comForm/comDetailControls/comShowImagesList.vue";
import EditArea from "@/0/components/comForm/comEditControls/comEditArea.vue";

// import EditEditor from "@/0/components/comForm/comEditControls/comEditEditor.vue";

import EditMapLocation from "@/0/components/comForm/comEditControls/comEditMapLocation.vue";

import AddmenDoload from "@/0/components/comForm/comEditControls/comAddmenDoload.vue";

import EditScanCodeInput from "@/0/components/comForm/comEditControls/comEditScanCodeInput.vue";
import EditScanCodeGroup from "@/0/components/comForm/comEditControls/comEditScanCodeGroup.vue";

import EditGiftNumber from "@/0/components/comForm/comEditControls/comGiftNumber.vue";
import EditGetImobel from "@/0/components/comForm/comEditControls/comMobileVerftion.vue";

import EditSearchChident from "@/0/components/comForm/comEditControls/comSearchIdentity.vue";
// import ShowMap from "@/0/components/comForm/comEditControls/comShowMap.vue";

import ShowSteps from "@/0/components/comForm/comEditControls/comEditSteps.vue";
// 弹出框组件
import ShowPoup from "@/0/components/comForm/comEditControls/comEditPoup.vue";
// 地址编辑组件
// comEditAddress
import EditAddress from "@/0/components/comForm/comEditControls/comEditAddress.vue";
// 地址列表组件
// import EditAddressList from "@/0/components/comForm/comEditControls/comEditAddressList.vue";

export default {
  props: ["groupBoxItem", "dataConfig"],
  components: {
    "show-text": ShowText,
    "show-table": ShowTable,
    "edit-hidden": EditHidden,

    "edit-common": EditCommon,
    "edit-dev01": EditDev01,
    "edit-dev02": EditDev02,
    "edit-dev03": EditDev03,
    "edit-dev04": EditDev04,
    "edit-dev05": EditDev05,
    "edit-dev06": EditDev06,
    "edit-dev07": EditDev07,


    "edit-input": EditInput,
    "edit-textarea": EditTextArea,

    // "edit-editor": EditEditor,

    "edit-date": EditDate,
    "edit-datetime": EditDateTime,

    "edit-switch": EditSwitch,
    "edit-checkbox": EditCheckBox,

    "edit-dropdownlist": EditDropDownList,
    "edit-linked-dropdownlist": EditLinkedDropDownList,
    "edit-radio-group": EditRadioGroup,

    "edit-uploader": EditUploader,
    "show-images-list": ShowImagesList,
    "edit-map-location": EditMapLocation,

    "edit-area": EditArea,
    "edit-drop-down-detail": EditDropDownDetail,

    "edit-scancode-input": EditScanCodeInput,
    "edit-scancode-group": EditScanCodeGroup,

    "addmen-doload": AddmenDoload,
    // "show-map": ShowMap,

    "show-steps": ShowSteps,
    // 弹出框组件
    "show-poup": ShowPoup,

    "edit-gift-number": EditGiftNumber,
    "edit-get-imobel": EditGetImobel,
    "edit-search-chident": EditSearchChident,
    // 地址编辑组件
    "edit-address": EditAddress
    // 地址列表组件
    // "edit-addresslist":EditAddressList,
  },
  data() {
    return {};
  },
  created() {
    this.initForm();
  },
  methods: {

    $getActionObj(){

      var actionObj = this.$parent.$getActionObj();
      return actionObj;
    },

    initForm() {
      if(!this.groupBoxItem) return;
      if(!this.groupBoxItem.ControlsList) return;

      this.groupBoxItem.ControlsList.forEach((controlItem, subIndex) => {
        if (controlItem.ControlType == "ImagesFilesUpload") {
          if (!controlItem.ControlValue) {
            controlItem.ControlValue = [];
          } else {
            controlItem.ControlValue = controlItem.ControlValue.split(",");
          }
        }
      });
    },

    $repostForm(url) {
      this.$parent.$repostForm(url);
    },

    getSubmitData() {
      this.$getSubmitData();
    },    

    $getSubmitData() {

      let submitData = {};
      if(!this.groupBoxItem) return submitData;
      if(!this.groupBoxItem.ControlsList) return submitData;

      this.groupBoxItem.ControlsList.forEach(controlItem => {
        // console.log("controlItem.ControlId", controlItem.ControlId);

        if (!controlItem.ControlId) return;
        if (controlItem.ControlType == "UEditor") {
          return;
        }

        if (
          controlItem.ControlValueList &&
          controlItem.ControlValueList.length > 0
        ) {
          controlItem.ControlValueList.forEach(m => {
            submitData[m.ControlId] = m.ControlValue;
          });
          console.log(
            "controlItem.ControlValueList",
            controlItem.ControlValueList
          );
        }

        if (controlItem.ControlType2 == "EditScanner") {
          console.log(controlItem, "EditScanner=controlItem");
          submitData[controlItem.ControlId] = controlItem.$getSubmitData();
          return;
        }

        if (controlItem.ControlType == "SMSCode") {
          console.log(controlItem, "controlItem");
          submitData[controlItem.ControlId] = controlItem.ControlValue;
          return;
        }
        
        if (controlItem.ControlType == "ImagesFilesUpload") {
          console.log(
            "this.$refs[controlItem.OpenId]",
            this.$refs[controlItem.OpenId]
          );

          try {
            var value = controlItem.getValue();
            console.log("ImagesFilesUpload-value", value);
            if (value && value.length > 0) {
              submitData[controlItem.ControlId] = value.join(",");
            } else {
              submitData[controlItem.ControlId] = null;
            }
          } catch (e) {
            console.log(e);
          }

          return;
        }

        console.log(controlItem.ControlId, controlItem.ControlValue);

        submitData[controlItem.ControlId] = controlItem.ControlValue;
      });

      return submitData;
    }
  }
};
